import { InstrumentTypeResponse } from "../../codegen-api";
import { isInstrumentTypeEnabled } from "../../config/features";
import { IMarketData } from "./MarketsTable";
import { MarketFiltersEnum } from "./CommandModal.types";

export const perpCategoryFilters = [
  MarketFiltersEnum.CRYPTO,
  MarketFiltersEnum.STOCKS,
  MarketFiltersEnum.COMMODITIES,
  MarketFiltersEnum.FX,
  MarketFiltersEnum.INDICES,
  MarketFiltersEnum.PRE_IPO,
];

/**
 * The palette's filter chips. The category chips (Crypto, Stocks, FX, ...)
 * classify the perp catalogue; a build without perpetuals offers only All and
 * Watchlist, instead of six chips that each opened an empty list. A function,
 * not a constant, so the flag is read when the palette renders.
 */
export const getMarketFilterOptions = (): MarketFiltersEnum[] => [
  MarketFiltersEnum.ALL_MARKETS,
  MarketFiltersEnum.WATCHLIST,
  ...(isInstrumentTypeEnabled(InstrumentTypeResponse.Perpetual)
    ? perpCategoryFilters
    : []),
];

export const normalizeMarketCategory = (
  category?: string,
  isPrelaunch?: boolean
): MarketFiltersEnum => {
  const normalized = category?.trim().toLowerCase();
  if (isPrelaunch || normalized === "pre-ipo" || normalized === "pre ipo") {
    return MarketFiltersEnum.PRE_IPO;
  }
  if (normalized === "stocks") return MarketFiltersEnum.STOCKS;
  if (normalized === "commodities") return MarketFiltersEnum.COMMODITIES;
  if (normalized === "fx") return MarketFiltersEnum.FX;
  if (normalized === "indices") return MarketFiltersEnum.INDICES;
  return MarketFiltersEnum.CRYPTO;
};

export const sortWatchlist = (a: IMarketData, b: IMarketData) => {
  if (a.isWatchlist && !b.isWatchlist) {
    return -1;
  }
  if (!a.isWatchlist && b.isWatchlist) {
    return 1;
  }
  return 0;
};

// millis
export const swrUpdateMillis = 5000;
